/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

import suggestionHighlight from './SuggestionHighlight';

const chance = new Chance();

const providers = [
  'Australian National University',
  'Curtin University',
  'Deakin University',
  'Edith Cowan University',
  'Flinders University',
  'Griffith University',
  'La Trobe University',
  'Macquarie University',
  'Polytechnic West',
  'Swinburne University of Technology',
  'Trinity College',
  'University of Melbourne',
];

export default () => {
  const provider = chance.pickone(providers);

  return {
    id: `http://graph.seek.com/EducationLibrary/${chance.integer({
      min: 0,
      max: 9999,
    })}`,
    matchedVariant: provider,
    normalisedText: provider,
    highlights: () => (chance.bool() ? [suggestionHighlight()] : []),
  };
};
